(function($){
    
	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: true,
        });
        
        /* Sticky Nav */
        var stickyNavTop = $('#masthead').offset().top,
            headerSize = $('#masthead').outerHeight(true);
		   	
        var stickyNav = function(){
            var scrollTop = $(window).scrollTop(); 
            
            if (scrollTop > headerSize) { 
                $('.site-header').addClass('sticky');
                $('#page').css('margin-top',headerSize);
            } else {
                $('.site-header').removeClass('sticky'); 
                $('#page').css('margin-top','');
            }
        };
        stickyNav();
        
        $(window).scroll(function() {
            stickyNav();
        });
        
        var resizeTimer;
        $(window).on('resize', function(e) {

          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {

            stickyNav();

          }, 250);

        });
        
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'));

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        
        /* Magnific Popup - Default */
        $('.popup-modal').magnificPopup({
            type: 'inline',
            preloader: false,
        });
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
        

        /* Sidr */
        $('#mobile-trigger').sidr({
            side: 'right',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                sidrHtml += '<span class="sidr__close" aria-label="Close Menu"></span>';
                
                sidrHtml += '<div class="sidr__inner">';
                
                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation').html() + '</div>';
                
                sidrHtml += '<div class="sidr__subnav">' + $('.site-header--subnav').html() + '</div>';
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                //alert('test');
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
            }
        });
        $('.menu-item-has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });
        
	});


})(jQuery);